export class CriptoJSConfig {
    static getKey(): string {
        return '2Vh4zs7UsVpF0Q+TOvPl83R3L+/X1bTN';
    }
}